import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Food - A&W Canada - Good food starts with simple ingredients.</title>
                    <meta name="description" content="Whether it’s high-quality meat like our beef, chicken and pork or fresh produce like our tomatoes, onions and cheese, good food is at the heart of what we do." />
                </Helmet>
            :
                <Helmet>
                    <title>Nos ingrédients - A&W Canada - Des ingrédients simples de premier choix.</title>
                    <meta name="description" content="Qu’il s’agisse de notre viande de haute qualité comme notre bœuf, notre poulet et notre porc ou de nos garnitures fraîches comme nos tomates, nos oignons ou notre fromage, la qualité de nos ingrédients est au cœur de ce que nous faisons." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;